import {
  BugTwoTone,
  BuildTwoTone,
  CloudTwoTone,
  CopyrightTwoTone,
  FunctionOutlined,
  HourglassTwoTone,
} from '@app/components/icons'

export const LOGGING_TABLE_DATA = [
  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <HourglassTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <HourglassTwoTone />,
      title: 'Zenefits',
    },
    userName: 'Pied Piper',
    date: 'Jun 30, 2022',
  },

  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <BugTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <BugTwoTone />,
      title: 'Salesflare',
    },
    userName: 'Lamp',
    date: 'May 12, 2022',
  },
  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <CloudTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <CloudTwoTone />,
      title: 'Breezy',
    },
    userName: 'Shyft',
    date: 'Aug 12, 2022',
  },
  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <CopyrightTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <CopyrightTwoTone />,
      title: 'CharlieHR',
    },
    userName: 'Roundmile',
    date: 'Aug 12, 2022',
  },

  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <BuildTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <BuildTwoTone />,
      title: 'Comeet',
    },
    userName: 'Vendeezy',
    date: 'Jun 30, 2022',
  },

  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <BugTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <BugTwoTone />,
      title: 'Salesflare',
    },
    userName: 'Lamp',
    date: 'May 12, 2022',
  },
  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <CloudTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <CloudTwoTone />,
      title: 'Breezy',
    },
    userName: 'Shyft',
    date: 'Aug 12, 2022',
  },
  {
    method: 'GET',
    url: 'https://asad-pj-next.vercel.app/dashboard',
    direction: {
      leftIcon: <FunctionOutlined />,
      rightIcon: <CopyrightTwoTone />,
    },
    status: '200 OK',
    integration: {
      icon: <CopyrightTwoTone />,
      title: 'CharlieHR',
    },
    userName: 'Roundmile',
    date: 'Aug 12, 2022',
  },
]
